import { Button } from "antd";
import { inject, observer } from "mobx-react";
import React from "react";
import AppStore from "../../Store";
import arrowLeft from "../../assets/images/arrow-left-icon.svg";
import QuestionPage from "../question/question";
import parse from "html-react-parser";
import "./terms-conditions.scss";
import FireRemoteService from "../../core/services/fire-remote";

@inject("appStore")
@observer
export default class TermsConditionsPage extends React.Component<{
  appStore: AppStore;
  history: any;
  location: Location;
}> {
  public static url: string = "/terms-conditions";

  render() {
    return (
      <div id="terms-conditions">
        <div className="page-title">
          <Button
            type="link"
            className="back-btn"
            children={<img src={arrowLeft} alt="left" />}
            onClick={() => (window.location.href = QuestionPage.url)}
          />
          <div className="title">
            {parse(
              FireRemoteService.getStringValue(
                FireRemoteService.bayram_conditions_header
              )
            )}
          </div>
        </div>
        <div className="content">
          {parse(
            FireRemoteService.getStringValue(
              FireRemoteService.bayram_conditions_desc
            )
          )}
        </div>
      </div>
    );
  }
}
